export const RPC_CONTENT_ENDPOINTS = {
    LIST: "/get_influencer_content_list",
    GET_BY_ID: "/get_influencer_content_by_id",
    CREATE: "/create_influencer_content",
    UPDATE: "/update_influencer_content",
    DELETE: "/delete_influencer_content",
};
